import BaseLayout from '@/layout/BaseLayout';
import { Tabs, TabsList, TabsTrigger } from '@shelflix/ui-web/components/ui/tabs';
import { useState } from 'react';
import { SwipeableTabs } from '@/components/SwipeableTabs';
import { DefinitionsTab } from './DefinitionsTab';
import { LogsTab } from './LogsTab';

export function WhatsAppNotifications() {
  const [activeTab, setActiveTab] = useState('definitions');
  const tabs = ['definitions', 'logs'];

  return (
    <BaseLayout>
      <div>
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="mb-4 ml-4 md:ml-0">
            <TabsTrigger value="definitions">Definições</TabsTrigger>
            <TabsTrigger value="logs">Logs</TabsTrigger>
          </TabsList>

          <SwipeableTabs currentTab={activeTab} tabs={tabs} onTabChange={setActiveTab}>
            <DefinitionsTab />
            <LogsTab />
          </SwipeableTabs>
        </Tabs>
      </div>
    </BaseLayout>
  );
}
